import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'

import ExternalLink from '../ExternalLink'

const ContentBottomBanner = () => (
  <ExternalLink href="https://lb.affilae.com/r/?p=62262ce1a69eb045574211b0&af=167&ad=79&lp=https%3A%2F%2Fwww.wespring.com%2F%3Futm_medium%3Daffiliation%26utm_source%3DPlan%25C3%25A8te-Durable%26utm_campaign%3DSPRiNG%2520-%2520Affinitaire%2520(blog%252C%2520m%25C3%25A9dia%252C%2520comparateur)" className='plausible-event-name=contentBottomBannerClick'>
    <StaticImage src="https://lb.affilae.com/imp/62262ce1a69eb045574211b0/6583367bb65edbce65b7fb70/62582a81163f764677630dfb/https://static.affilae.com/uploads/programs/62262ce1a69eb045574211b0/elements/62582a81163f764677630df9.jpg" width={970} height={250} alt="" />
  </ExternalLink>
)

ContentBottomBanner.propTypes = {}

export default ContentBottomBanner
